// Pre-signup onboarding, Measurement Core v1.3.12 §6.2: the six screens before
// account creation.
//
//   onboarding_begin          the first screen opens
//   onboarding_step_view      a screen appears (screen_number 1-6)
//   onboarding_path_selected  a choice is committed and the user advances
//   onboarding_complete       all six screens finished, account creation reached
//   onboarding_skip           skipped to account creation (screen_number)
//
// The chosen onboarding_path is also kept here until the account is created,
// then sent with the signup / social-login request so the backend saves it on
// the account and attaches it to sign_up and the first/second trade milestones.
// GA4 in a browser, Firebase in the app; never AppsFlyer or ad platforms.
// screen_number is sent as text ("screen_3"), Mantis note 15231.
import { trackClientEvent } from "./measurement";

const KEY = "qushi_onboarding_path";

// The persona buttons on screen 6 → the spec's controlled values.
export const ONBOARDING_PATHS = {
  new: "brand_new_to_trading",
  basics: "knows_basics_wants_practice",
  experienced: "experienced_wants_compete",
  creator: "build_following_and_monetize",
};
export const NOT_SELECTED = "not_selected";

const savePath = (path) => {
  try {
    localStorage.setItem(KEY, path);
  } catch (e) { }
};

/** The path to send with the request that creates the account, if any. */
export const onboardingPathForSignup = () => {
  try {
    const path = localStorage.getItem(KEY);
    return path === NOT_SELECTED || Object.values(ONBOARDING_PATHS).includes(path) ? path : undefined;
  } catch (e) {
    return undefined;
  }
};

export const trackOnboardingStepView = (screenNumber) => {
  if (screenNumber === 1) trackClientEvent("onboarding_begin");
  trackClientEvent("onboarding_step_view", { screen_number: `screen_${screenNumber}` });
};

export const trackOnboardingPathSelected = (persona) => {
  const path = ONBOARDING_PATHS[persona];
  if (!path) return;
  savePath(path);
  trackClientEvent("onboarding_path_selected", { onboarding_path: path });
  trackClientEvent("onboarding_complete", { onboarding_path: path });
};

export const trackOnboardingSkip = (screenNumber) => {
  savePath(NOT_SELECTED);
  trackClientEvent("onboarding_skip", { screen_number: `screen_${screenNumber}` });
};
